import { isMobile } from '../../scripts/helpers';

export default class ContainerResults {
  constructor() {
    var containerTabs = document.querySelector('.container-results__tabs');
    var containerItems = document.querySelector('.container-results__items');

    if(typeof(containerTabs) != 'undefined' && containerTabs != null && typeof(containerItems) != 'undefined' && containerItems != null ) {
      if(isMobile()) {
        $('.container-results__tabs').slick({
          centerMode: false,
          slidesToShow: 2,
          dots: false,
          arrows: false,
          slidesToScroll: 2,
          asNavFor: '.container-results__items',
          focusOnSelect: true,
          infinite: false
        });
        
        $('.container-results__items').slick({
          centerMode: false,
          slidesToShow: 1,
          dots: false,
          arrows: false,
          slidesToScroll: 1,
          infinite: false,
          asNavFor: '.container-results__tabs'
        });
      }
    }

    var labelCheck = document.querySelector('.label-check.result-item__footer-item');

    if(typeof(labelCheck) != 'undefined' && labelCheck != null) {
      var containerCompare = document.querySelector('.container-results__compare');

      document.querySelectorAll('.label-check.result-item__footer-item').forEach(element => {
        element.addEventListener('click', function() {
          if (document.querySelectorAll('.container-results__items .result-item__footer label input:checked').length > 0 && !containerCompare.classList.contains('container-results__compare--active')) {
            containerCompare.classList.add('container-results__compare--active');
          } else {
            containerCompare.classList.remove('container-results__compare--active');
          }
        });
      });
    }
  }
}

const containerResults = new ContainerResults();